import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import ResponsiveContainer from './ResponsiveContainer';

function EmailConfirmationPage({
  personalDetails,
  setPersonalDetails,
  t,
}) {
  const navigate = useNavigate();
  const [agendaEmail, setAgendaEmail] = useState(personalDetails.email);
  const [adminEmail, setAdminEmail] = useState(personalDetails.invoiceEmail);
  const [error, setError] = useState('');
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);

  const handleConfirm = async () => {
    if (agendaEmail.trim() !== personalDetails.email.trim() || adminEmail.trim() !== personalDetails.invoiceEmail.trim()) {
      const result = await Swal.fire({
        title: t('confirmEmailAddress') || 'Confirm Emails',
        html: `
          <div style="text-align:left">
            <p><strong>${t('enterAdminEmailAddress')}:</strong><br/> ${adminEmail}</p>
            <p style="margin-top:10px;"><strong>${t('enterAgendaEmailAddress')}:</strong><br/> ${agendaEmail}</p>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: t('yes') || 'Yes, confirm',
        cancelButtonText: t('no') || 'No',
        confirmButtonColor: '#d0a949',
        cancelButtonColor: '#6b7280',
      });

      if (result.isConfirmed) {
        setPersonalDetails({
          ...personalDetails,
          email: agendaEmail.trim(),
          invoiceEmail: adminEmail.trim(),
        });

        navigate('/send-confirmation');
      }
    }else{
      navigate('/send-confirmation');
    }
    
  };

  const handleCancel = () => {
    navigate('/digital-signature');
  };
  
  const handleCancelRegistration = () => {
    setShowCancelConfirmation(true);
  };
  
  const handleConfirmCancellation = (confirmed) => {
    setShowCancelConfirmation(false);
    if (confirmed) {
      navigate('/');
    }
  };

  return (
    <ResponsiveContainer>
      <div className="min-h-[calc(100vh-100px)] bg-gray-100 py-6 px-4">
        <div className="bg-white rounded-lg shadow-lg p-6 max-w-3xl mx-auto">
          <h2 className="text-2xl font-semibold mb-4">{t('confirmEmailAddress')}</h2>
          
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t('enterAdminEmailAddress')}:
            </label>
            <div className="bg-gray-100 p-3 rounded border border-gray-300">
              {personalDetails.invoiceEmail}
            </div>
          </div>
          
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t('confirmYourEmail')}:
            </label>
            <input
              type="email"
              value={adminEmail}
              onChange={(e) => {
                setAdminEmail(e.target.value);
                setError('');
              }}
              className={`w-full p-3 border ${error ? 'border-red-500' : 'border-gray-300'} rounded focus:outline-none focus:ring-2 focus:ring-blue-500`}
              placeholder={t('reEnterEmail')}
            />
            {error && (
              <p className="text-red-500 text-sm mt-1">{error}</p>
            )}
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t('enterAgendaEmailAddress')}:
            </label>
            <div className="bg-gray-100 p-3 rounded border border-gray-300">
              {personalDetails.email}
            </div>
          </div>
          
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {t('confirmYourEmail')}:
            </label>
            <input
              type="email"
              value={agendaEmail}
              onChange={(e) => {
                setAgendaEmail(e.target.value);
                setError('');
              }}
              className={`w-full p-3 border ${error ? 'border-red-500' : 'border-gray-300'} rounded focus:outline-none focus:ring-2 focus:ring-blue-500`}
              placeholder={t('reEnterEmail')}
            />
            {error && (
              <p className="text-red-500 text-sm mt-1">{error}</p>
            )}
          </div>
          
          <div className="flex justify-between pt-4">
            <div>
              <button
                onClick={handleCancel}
                className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition duration-200 mr-2"
              >
                {t('back')}
              </button>
              <button
                onClick={handleCancelRegistration}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition duration-200"
              >
                {t('cancelRegistration') || 'Cancel Registration'}
              </button>
            </div>
            
            <button
              onClick={handleConfirm}
              className="px-4 py-2 bg-[#d0a949] text-white rounded-md hover:bg-[#a6873a] transition duration-200"
            >
              {t('confirmAndSend')}
            </button>
          </div>
        </div>
      </div>
      
      {/* Cancel Registration Confirmation Modal */}
      {showCancelConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm mx-auto">
            <h3 className="text-lg font-semibold mb-4">{t('confirmCancellation') || 'Confirm Cancellation'}</h3>
            <p className="mb-6">{t('cancelRegistrationConfirmation') || 'Are you sure you want to cancel this registration?'}</p>
            
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => handleConfirmCancellation(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition duration-200"
              >
                {t('no') || 'No'}
              </button>
              <button
                onClick={() => handleConfirmCancellation(true)}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition duration-200"
              >
                {t('yes') || 'Yes'}
              </button>
            </div>
          </div>
        </div>
      )}
    </ResponsiveContainer>
  );
}

export default EmailConfirmationPage;
